import { Fragment } from 'react'

import { useNavigation } from '@/hooks/useNavigation'

import { Dropdown } from '@/components/Dropdown'

import { CONSUMER_LINKS, BUSINESS_LINKS } from './constants'

import styles from './NavigationLinks.module.scss'

const NavigationLink = ({ link, variant, customClass, onClick }) => {
  return (
    <a
      rel="noreferrer"
      target={link.target}
      id={`${variant}-${link.id}-link`}
      href={link.path}
      className={`${styles.navigation__link} ${customClass}`}
      onClick={onClick}
    >
      {link.label}
    </a>
  )
}

export const NavigationLinks = ({ variant, category, onClick }) => {
  const { urlParams } = useNavigation()

  const headerNavigationLinks = {
    consumer: CONSUMER_LINKS,
    business: BUSINESS_LINKS
  }

  const getLink = (link) => {
    if (link.target === '_blank') return link

    return { ...link, path: `${link.path}${urlParams}` }
  }

  return (
    <nav className={styles[`navigation--${variant}`]}>
      {headerNavigationLinks[category].map((link) => (
        <Fragment key={`${variant}-${link.id}-link`}>
          {!link.children && (
            <NavigationLink
              link={getLink(link)}
              variant={variant}
              onClick={onClick}
              key={`${variant}-${link.id}-link`}
            />
          )}

          {link.children && (
            <>
              <Dropdown
                id={link.id}
                section={variant}
                label={link.label}
                links={link.children}
                customClass={styles.navigation__dropdown}
              />

              {link.children.map((link) => (
                <NavigationLink
                  link={link}
                  variant={variant}
                  onClick={onClick}
                  key={`${variant}-${link.id}-link`}
                  customClass={styles.navigation__children}
                />
              ))}
            </>
          )}
        </Fragment>
      ))}
    </nav>
  )
}
